import { Box, Flex, Text } from '@optiaxiom/react';

import { MarkdownText } from '@frontend/components/MarkdownText';

import { EmptyStateMessage } from './EmptyStateMessage';
import { markdownContainer } from './ExecutionOutputDisplay.css';

type ExecutionOutputDisplayProps = {
  result: {
    response?: string;
    error?: string;
  } | null;
  status?: string;
  showStatus?: boolean;
  emptyMessage?: string;
  emptySubMessage?: string;
};

export function ExecutionOutputDisplay({
  result,
  status,
  showStatus = true,
  emptyMessage = 'No output available.',
  emptySubMessage = 'Execute the agent to see results here.',
}: ExecutionOutputDisplayProps) {
  if (!result || (!result.response && !result.error)) {
    return <EmptyStateMessage message={emptyMessage} subMessage={emptySubMessage} />;
  }

  return (
    <Box border="1" borderColor="border.default" rounded="md">
      <Flex flexDirection="column">
        {showStatus && status && (
          <Box bg="bg.secondary" p="12" rounded="md">
            <Text fontSize="sm">
              <strong>Status:</strong> {status}
            </Text>
          </Box>
        )}
        <Box bg="bg.default" p="12" rounded="md" className={markdownContainer}>
          <MarkdownText text={result.response ?? `Error: ${result.error}`} />
        </Box>
      </Flex>
    </Box>
  );
}
